import { useState } from 'react'
import { Box, IconButton, Stack, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { PrimaryButton } from '$common/buttons'
import { TextInput } from '$common/input'
import { Label } from '$common/label'
import { createCollection, editCollection } from '$logic/bookmark'
import { ArrowRightIcon } from '$common/icons'
import { t } from '$i18n'

const Root = styled(Stack)`
  padding: 20px 10px 5px;
`

interface Props {
  onDone: (affected: boolean) => unknown
  oldTitle?: string
  isOpen?: boolean
}

export function CreateBookmarkCollectionModal({
  onDone,
  oldTitle,
  isOpen,
}: Props) {
  const [name, setName] = useState<string>(oldTitle || '')
  const [hasError, setHasError] = useState<boolean>(false)

  const handleClose = () => {
    closeCurrentModal()
    onDone(false)
  }

  const onSubmit = async () => {
    if (!name) {
      setHasError(true)
      return
    }
    if (oldTitle) await editCollection(oldTitle, name)
    else await createCollection(name)
    closeCurrentModal()
    onDone(true)
  }

  return (
    <BottomDrawer isOpen={isOpen!} onClose={handleClose}>
      <Root>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-start',
            marginBottom: '20px',
            alignItems: 'center',
            marginRight: '5px',
          }}
          gap="5px"
        >
          <IconButton
            onClick={handleClose}
            sx={{ width: '24px', height: '24px' }}
          >
            <ArrowRightIcon color="primary" />
          </IconButton>
          <Typography variant="subtitle1" color="primary">
            {oldTitle
              ? t('bookmarkSelectionListModal.editCollection')
              : t('bookmarkSelectionListModal.createCollection')}
          </Typography>
        </Box>
        <Stack padding="12px 20px" height="125px">
          <Label title={t('bookmarkMakeListModal.title')} />
          <TextInput
            onChange={newName => {
              setHasError(false)
              setName(newName)
            }}
            value={name}
            placeholder={t('bookmarkMakeListModal.placeholder')}
            hasError={hasError}
            errorMessage={t('bookmarkMakeListModal.shouldNotBeEmpty')}
          />
        </Stack>

        <Stack padding="20px" direction="row" width="100%" gap="12px">
          <PrimaryButton
            fullWidth
            text={
              oldTitle ? t('common.ok') : t('bookmarkSelectionListModal.add')
            }
            onClick={onSubmit}
          />
        </Stack>
      </Root>
    </BottomDrawer>
  )
}

CreateBookmarkCollectionModal.defaultProps = {
  oldTitle: '',
  isOpen: false,
}
